export const PAGE_NAME = 'registration';
export const USER_SIGNED_UP = 'registrationPage/USER_SIGNED_UP';
export const REGISTRATION_REQUEST = 'registrationPage/REGISTRATION_REQUEST';
